import { Injectable } from '@angular/core';

@Injectable()
export class ViewerActions {

    static UPDATE = '[Viewer] Update';
    static ACTIVATED = '[Viewer] Activated';
    static ADD = '[Viewer] AddEntries';

    public Show(fileName: String, hasMoreResults: boolean, continuationToken: string, content: Array<IBATraceDetail>): any {
        return {
            type: ViewerActions.UPDATE,
            payload: {
                fileName,
                content,
                hasMoreResults,
                continuationToken
            }
        };
    }

    public Activated(tab: string) {
        return {
            type: ViewerActions.ACTIVATED,
            payload: {
                tab
            }
        }
    }

    public Add(entries: Array<IBATraceFile>) {
        return {
            type: ViewerActions.ADD,
            payload: {
                entries
            }
        }
    }
}
